import { navigate } from "gatsby";
import React from "react";

const Layout_1 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgt-5"><img onClick={()=>handleClick(item[0].link)} src={item[0].images} alt={item.name} style={{width:'100%', height:250}}/></div>
    )
}
const Layout_2 =({item})=>{
    const handleClick=(uri)=>{
        if(uri.includes('bibomart://landing-page') === true){
            window.location.href = uri.replaceAll('bibomart://landing-page?id=','/page/landing-page.html?');
        }else{
            navigate(uri);
        }
    }
    return(
        <div className="row mgt-5"><img onClick={()=>handleClick(item[0].link)} src={item[0].images} alt={item.name} style={{width:'100%', height:470}}/></div>
    )
}

export {Layout_1,Layout_2}